

import { MultigameParams } from "../../MultigameParams";
import { SlotGameInitData } from "../../SlotGameInitData";
import { GoldAndRum_ResponsivePIXIApp } from "../GoldAndRum/game_ResponsivePIXIApp";


export class GoldAndRumLink_ResponsivePIXIApp extends GoldAndRum_ResponsivePIXIApp {
    constructor(multigameParams: MultigameParams, initData: SlotGameInitData) {
        super(multigameParams, initData, "GoldAndRumLink");
    }
}